
export function filter(state) {

  return state.filters.find(
    v => v.name === state.filter,
  );
}
